/**
 * presets.js
 * ─────────────────────────────────────────────────────────────
 * Each preset is a full fleet-export payload (same schema as
 * the JSON produced by "Export" in the tool).  Add or edit
 * entries here to extend the preset library shown in the
 * startup modal.
 *
 * Required top-level keys:
 *   name          – display name shown in the modal
 *   description   – one-line summary shown below the name
 *   version       – payload version (use 3)
 *   routes        – array of route objects
 *   fuelParams    – fuel parameter overrides (can be {})
 *   euFactors     – EU regulation factors
 *   activeFuelIds – array of fuel IDs active in this preset
 *   customFuels   – array of custom fuel objects (can be [])
 * ─────────────────────────────────────────────────────────────
 */

export const PRESETS = [
  {
    "name": "Webinar Case 1 – Bunker choice under FuelEU (The cost of inaction)",
    "description": "Continuing to bunker conventional fossil MGO on the Callao–Hamburg route locks the operator into structural non-compliance with FuelEU Maritime, with penalty costs escalating sharply as targets tighten through 2050.",
  "version": 4,
  "exportedAt": "2026-06-19T17:08:59.359Z",
  "routes": [
    {
      "id": "1781885270255-leg1-1781885287864",
      "name": "Case1_S0 — leg 1",
      "ports": [
        {
          "id": "Callao"
        },
        {
          "id": "Balboa"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg2-1781885287864",
      "name": "Case1_S0 — leg 2",
      "ports": [
        {
          "id": "Balboa"
        },
        {
          "id": "Cartagena"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg3-1781885287864",
      "name": "Case1_S0 — leg 3",
      "ports": [
        {
          "id": "Cartagena"
        },
        {
          "id": "Algeciras"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg4-1781885287864",
      "name": "Case1_S0 — leg 4",
      "ports": [
        {
          "id": "Algeciras"
        },
        {
          "id": "Rotterdam"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg5-1781885287864",
      "name": "Case1_S0 — leg 5",
      "ports": [
        {
          "id": "Rotterdam"
        },
        {
          "id": "Hamburg"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "",
          "blend1Share": "5.1",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "__KEEP_PREVIOUS__",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    }
  ],
  "fuelParams": {
    "e_MeOH_CO2_AEL_PS": {
      "cost": 1090.61,
      "costLow": 846.38,
      "costHigh": 1355.7,
      "co2": 0.01,
      "hfoEquivalentFactor": 0.495,
      "lhvMJperT": 19900
    },
    "bio_MeOH_biogas_AD_Manure": {
      "cost": 1138.93,
      "costLow": 850.07,
      "costHigh": 1473.8,
      "co2": -4.79,
      "hfoEquivalentFactor": 0.495,
      "lhvMJperT": 19900
    }
  },
  "euFactors": {},
  "activeFuelIds": [
    "HFO",
    "VLSFO",
    "MGO",
    "LNG",
    "Methanol",
    "Ammonia",
    "e_MeOH_CO2_AEL_PS"
  ],
  "customFuels": []
},
{
  "name": "Webinar Case 1 – Bunker choice under FuelEU (E-methanol transition)",
    "description": "Blending in e-methanol realigns the vessel's fuel mix with the tightening FuelEU trajectory, trading away escalating penalty exposure for a predictable and scalable, if costlier, clean fuel investment.",
  "version": 4,
  "exportedAt": "2026-06-19T17:09:28.505Z",
  "routes": [
    {
      "id": "1781885270255-leg1-1781885287864",
      "name": "Case1_S0 — leg 1",
      "ports": [
        {
          "id": "Callao"
        },
        {
          "id": "Balboa"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg2-1781885287864",
      "name": "Case1_S0 — leg 2",
      "ports": [
        {
          "id": "Balboa"
        },
        {
          "id": "Cartagena"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg3-1781885287864",
      "name": "Case1_S0 — leg 3",
      "ports": [
        {
          "id": "Cartagena"
        },
        {
          "id": "Algeciras"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "29.7",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "63.5",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg4-1781885287864",
      "name": "Case1_S0 — leg 4",
      "ports": [
        {
          "id": "Algeciras"
        },
        {
          "id": "Rotterdam"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "14.3",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "59",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg5-1781885287864",
      "name": "Case1_S0 — leg 5",
      "ports": [
        {
          "id": "Rotterdam"
        },
        {
          "id": "Hamburg"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "5.1",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "57.5",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    }
  ],
  "fuelParams": {
    "e_MeOH_CO2_AEL_PS": {
      "cost": 1090.61,
      "costLow": 846.38,
      "costHigh": 1355.7,
      "co2": 0.01,
      "hfoEquivalentFactor": 0.495,
      "lhvMJperT": 19900
    },
    "bio_MeOH_biogas_AD_Manure": {
      "cost": 1138.93,
      "costLow": 850.07,
      "costHigh": 1473.8,
      "co2": -4.79,
      "hfoEquivalentFactor": 0.495,
      "lhvMJperT": 19900
    }
  },
  "euFactors": {},
  "activeFuelIds": [
    "HFO",
    "VLSFO",
    "MGO",
    "LNG",
    "Methanol",
    "Ammonia",
    "e_MeOH_CO2_AEL_PS"
  ],
  "customFuels": []
},
{
  "name": "Webinar Case 1 – Bunker choice under FuelEU (Biomethanol opportunity)",
    "description": "Carbon-negative biomethanol from manure-derived biogas offers the most cost-effective route to compliance, but its scarce feedstock and strict certification requirements mean it works as a complement rather than a fleet-wide solution.",
  "version": 4,
  "exportedAt": "2026-06-19T17:10:04.087Z",
  "routes": [
    {
      "id": "1781885270255-leg1-1781885287864",
      "name": "Case1_S0 — leg 1",
      "ports": [
        {
          "id": "Callao"
        },
        {
          "id": "Balboa"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg2-1781885287864",
      "name": "Case1_S0 — leg 2",
      "ports": [
        {
          "id": "Balboa"
        },
        {
          "id": "Cartagena"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg3-1781885287864",
      "name": "Case1_S0 — leg 3",
      "ports": [
        {
          "id": "Cartagena"
        },
        {
          "id": "Algeciras"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "e_MeOH_CO2_AEL_PS",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg4-1781885287864",
      "name": "Case1_S0 — leg 4",
      "ports": [
        {
          "id": "Algeciras"
        },
        {
          "id": "Rotterdam"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "0",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "1.2",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "24.1",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "37.5",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    },
    {
      "id": "1781885270255-leg5-1781885287864",
      "name": "Case1_S0 — leg 5",
      "ports": [
        {
          "id": "Rotterdam"
        },
        {
          "id": "Hamburg"
        }
      ],
      "vessel": {
        "preset": "panamax",
        "name": "",
        "type": "Container",
        "capacity": {
          "value": 5000,
          "unit": "TEU"
        },
        "speed": {
          "value": 19,
          "unit": "kn"
        },
        "fuel": {
          "type": "MGO",
          "consumption": 52.81
        }
      },
      "scenario": {
        "alt1": "",
        "share1": 50,
        "alt2": "",
        "share2": 50
      },
      "scenarioTimeline": {
        "2025": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "1.4",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2030": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "15.8",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2035": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "46.2",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2040": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2045": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        },
        "2050": {
          "baseFuel": "MGO",
          "blend1Fuel": "bio_MeOH_biogas_AD_Manure",
          "blend1Share": "100",
          "blend2Fuel": "",
          "blend2Share": "",
          "active": true
        }
      },
      "operations": {
        "tripsPerYear": 35
      }
    }
  ],
  "fuelParams": {
    "e_MeOH_CO2_AEL_PS": {
      "cost": 1090.61,
      "costLow": 846.38,
      "costHigh": 1355.7,
      "co2": 0.01,
      "hfoEquivalentFactor": 0.495,
      "lhvMJperT": 19900
    },
    "bio_MeOH_biogas_AD_Manure": {
      "cost": 1138.93,
      "costLow": 850.07,
      "costHigh": 1473.8,
      "co2": -4.79,
      "hfoEquivalentFactor": 0.495,
      "lhvMJperT": 19900
    }
  },
  "euFactors": {},
  "activeFuelIds": [
    "HFO",
    "VLSFO",
    "MGO",
    "LNG",
    "Methanol",
    "Ammonia",
    "e_MeOH_CO2_AEL_PS",
    "bio_MeOH_biogas_AD_Manure"
  ],
  "customFuels": []
},
  {
    "name": "Webinar Case 2 – Reframing route economics (Fossil lock-in)",
    "description": "Current Tuticorin–Colombo–Rotterdam logistics remain tied to fossil MGO, creating a structurally non-compliant route under FuelEU and exposing operators to rapidly escalating penalty costs over time.",
    "version": 4,
    "exportedAt": "2026-06-19T15:24:06.334Z",
    "routes": [
      {
        "id": 1781828590046,
        "name": "Leg1. VOC - Colombo",
        "ports": [
          {
            "id": "Tuticorin"
          },
          {
            "id": "Colombo"
          }
        ],
        "vessel": {
          "preset": "feeder",
          "name": "",
          "type": "Container",
          "capacity": {
            "value": 1000,
            "unit": "TEU"
          },
          "speed": {
            "value": 16,
            "unit": "kn"
          },
          "fuel": {
            "type": "MGO",
            "consumption": 25
          }
        },
        "scenario": {
          "alt1": "",
          "share1": 50,
          "alt2": "",
          "share2": 50
        },
        "scenarioTimeline": {
          "2025": {
            "baseFuel": "MGO",
            "blend1Fuel": "",
            "blend1Share": "",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          },
          "2030": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2035": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2040": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2045": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2050": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          }
        },
        "operations": {
          "tripsPerYear": 122
        }
      },
      {
        "id": 1781828631959,
        "name": "Leg2. Colombo- Rotterdam",
        "ports": [
          {
            "id": "Colombo"
          },
          {
            "id": "Rotterdam"
          }
        ],
        "vessel": {
          "preset": "postpanamax",
          "name": "",
          "type": "Container",
          "capacity": {
            "value": 8000,
            "unit": "TEU"
          },
          "speed": {
            "value": 20,
            "unit": "kn"
          },
          "fuel": {
            "type": "MGO",
            "consumption": 67.21
          }
        },
        "scenario": {
          "alt1": "",
          "share1": 50,
          "alt2": "",
          "share2": 50
        },
        "scenarioTimeline": {
          "2025": {
            "baseFuel": "MGO",
            "blend1Fuel": "",
            "blend1Share": "",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          },
          "2030": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2035": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2040": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2045": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          },
          "2050": {
            "baseFuel": "__KEEP_PREVIOUS__",
            "blend1Fuel": "__KEEP_PREVIOUS__",
            "blend1Share": "__KEEP_PREVIOUS__",
            "blend2Fuel": "__KEEP_PREVIOUS__",
            "blend2Share": "__KEEP_PREVIOUS__",
            "active": true
          }
        },
        "operations": {
          "tripsPerYear": 52
        }
      }
    ],
    "fuelParams": {
      "e_LNG_CO2_PEM_PS": {
        "cost": 3106.59,
        "costLow": 2407.57,
        "costHigh": 3874.79,
        "co2": 0.1,
        "hfoEquivalentFactor": 1.209,
        "lhvMJperT": 48600
      }
    },
    "euFactors": {},
    "useOptimalAllocation": false,
    "customFuels": []
  },
  {
    "name": "Webinar Case 2 – Reframing route economics (NH3 corridor shift)",
    "description": "A future direct VOC Port–Rotterdam route supplied with Indian ammonia redefines the corridor from a fossil transshipment pathway into a low-carbon export and bunkering platform, materially reducing FuelEU exposure and supporting VOC’s role as a future supplier of green ammonia into Europe.",
    "version": 4,
    "exportedAt": "2026-06-19T15:38:55.252Z",
    "routes": [
      {
        "id": 1781829937960,
        "name": "Case2. NH3 VOC Port",
        "ports": [
          {
            "id": "Tuticorin"
          },
          {
            "id": "Algeciras"
          },
          {
            "id": "Rotterdam"
          }
        ],
        "vessel": {
          "preset": "postpanamax",
          "name": "",
          "type": "Container",
          "capacity": {
            "value": 8000,
            "unit": "TEU"
          },
          "speed": {
            "value": 20,
            "unit": "kn"
          },
          "fuel": {
            "type": "MGO",
            "consumption": 67.21
          }
        },
        "scenario": {
          "alt1": "",
          "share1": 50,
          "alt2": "",
          "share2": 50
        },
        "scenarioTimeline": {
          "2025": {
            "baseFuel": "MGO",
            "blend1Fuel": "NH3_indian_standard",
            "blend1Share": "0.2",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          },
          "2030": {
            "baseFuel": "MGO",
            "blend1Fuel": "NH3_indian_standard",
            "blend1Share": "1.3",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          },
          "2035": {
            "baseFuel": "MGO",
            "blend1Fuel": "NH3_indian_standard",
            "blend1Share": "8.4",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          },
          "2040": {
            "baseFuel": "MGO",
            "blend1Fuel": "NH3_indian_standard",
            "blend1Share": "19",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          },
          "2045": {
            "baseFuel": "MGO",
            "blend1Fuel": "NH3_indian_standard",
            "blend1Share": "39.1",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          },
          "2050": {
            "baseFuel": "MGO",
            "blend1Fuel": "NH3_indian_standard",
            "blend1Share": "100",
            "blend2Fuel": "",
            "blend2Share": "",
            "active": true
          }
        },
        "operations": {
          "tripsPerYear": 52
        }
      }
    ],
    "fuelParams": {
      "e_LNG_CO2_PEM_PS": {
        "cost": 3106.59,
        "costLow": 2407.57,
        "costHigh": 3874.79,
        "co2": 0.1,
        "hfoEquivalentFactor": 1.209,
        "lhvMJperT": 48600
      },
      "NH3_indian_standard": {
        "cost": 610,
        "costLow": 565,
        "costHigh": 740,
        "co2": 0.376,
        "hfoEquivalentFactor": 0.4677,
        "lhvMJperT": 18800,
        "isRfnbo": true
      }
    },
    "euFactors": {},
    "activeFuelIds": [
      "HFO",
      "VLSFO",
      "MGO",
      "LNG",
      "Methanol",
      "Ammonia",
      "NH3_indian_standard"
    ],
    "useOptimalAllocation": true,
    "customFuels": [
      {
        "id": "NH3_indian_standard",
        "name": "NH3 indian standard",
        "category": "E-fuel",
        "color": "#fbbf24",
        "lhv": {
          "value": 18.8,
          "unit": "MJ/kg"
        },
        "density": {
          "value": 0.68,
          "unit": "t/m3"
        },
        "hfoEquivalentFactor": {
          "value": 0.4677,
          "unit": "tHFOeq/tFuel"
        },
        "cost": {
          "value": 610,
          "unit": "USD/t"
        },
        "costLow": 565,
        "costHigh": 740,
        "co2": {
          "value": 0.376,
          "unit": "tCO2/tFuel"
        },
        "tags": {
          "tag1": "E-fuel",
          "tag2": "Ammonia",
          "tag3": "e-NH3",
          "tag4": "AEL"
        }
      }
    ]
  }
];